const BOUNDS = 'bounds'
const COUNTY = 'county'

export const VIEW_TYPES = {
  BOUNDS,
  COUNTY,
}
